import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { Component, OnInit, Input, AfterViewInit, QueryList, ViewChild } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import * as moment from 'moment/moment';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { QueryByStatusDTO } from 'src/app/models/internal/query-bystatus-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserData } from '../../../models/auth/userdata';
import { SelectedAutocompleteValue } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.model';
import { SourceType } from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { NGXLogger } from 'ngx-logger';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import UIHelper from 'src/app/core/utility/ui-helper';
import { PackageType } from 'src/app/models/packagetype';
import { UserPermissions } from '../../../permissions';
import { AuthService } from 'src/app/auth/services/auth.service';


@Component({
  selector: 'app-estimaterequestlist',
  templateUrl: './estimate-request-list-pe.component.html',
  styleUrls: ['./estimate-request-list-pe.component.scss']
})
export class EstimaterequestlistPEComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData {

    excelFilenamePrefix = "EstimateRequestList_PE_";
    appSettings: AppSettings;
    requestList: ReviewProposalPartInfo[];
    allItemsCheckBoxSelected: boolean = false;
    autoCompletePEURL: string;
    searchSupplierURL: string;
    filterForm: FormGroup;
    IsPE: boolean;
    engineerDisplay: string;
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    sourceTypeList: SourceType[];
    EstimateRequestStatus = [{ text: 'New', value: 1 }, { text: 'Submitted', value: 2 }, { text: 'Rejected', value: 3 }, { text: 'Approved', value: 4 }];

    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        localstorageService: LocalstorageService,
        private router: Router,
        private authService: AuthService,
        private fb: FormBuilder,
        private toastService: ToastService,
        logger: NGXLogger,
        appSettings: AppSettings,
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            PartNumber: [null],
            SupplierCode: [null],
            PackageEngineerEmail: [null],
            SourceTypeId: [null],
            StatusId:[null],
        });

        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
    

    }

    //tms-29146 Due to performance, Launch review proposal screen as blank without any filtered records based on logged in PE value.
    ngOnInit() {
        this.getSourceTypes();
        this.initFilterValues();
        // pre-populate and run search if PE
        const UserDisplayName = this.localstorageService.retrieve(Constants.localStorageKeys.UserDisplayName);
        this.filterForm.controls['PackageEngineerEmail'].patchValue(this.CurrentUserEmail);
        this.fillGrid();
    }


    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        this.getEstimateRequests();
    }
    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageEngineerEmail', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'StatusId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }
    clearFilter() {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.search();
    }
    exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryByStatusDTO: QueryByStatusDTO = new QueryByStatusDTO();
        queryByStatusDTO.SearchFilter = this.filter;
        this.dataService.getEstimateRequestsExcelForPE(queryByStatusDTO).subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }

    viewEstimate(id: number)
    {
        window.open('pe-viewestimate/' + id, '_blank');
    }
   
    getEstimateRequests() {
        this.UpdateFilter();
        const queryByStatusDTO: QueryByStatusDTO = new QueryByStatusDTO();
        queryByStatusDTO.SearchFilter = this.filter;
        this.dataService
            .getEstimateRequests(queryByStatusDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                if (response != null) {
                    this.requestList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                }
                if (this.requestList.length === 0) {
                    this.mainGrid = undefined;
                }
            });
    }

    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
    }

    onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
        if (isSelected) {
            this.requestList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = true;
            if (
                this.requestList.filter(a => a.IsSelected === true)
                    .length === this.requestList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
        } else {
            this.requestList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.requestList
        );
    }

    setAllSelected(isSelected: boolean) {
        // this.partinfoList.map(function(part) {
        //     part.IsSelected = isSelected;
        //     return part;
        // });
        this.requestList.forEach(part => {
            part.IsSelected = isSelected;
        });
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.requestList
        );
    }

    getAllSelectedOrNot(getSelected: boolean): number[] {
        return this.requestList
            .filter(a => a.IsSelected === getSelected)
            .map(prop => prop.Id);
    }

    ValidateForm() {
        // console.log(this.gridData);
    }

    onEmptyPE(eventObj: any): void {
        this.filterForm.controls['PackageEngineerEmail'].patchValue(null);
        this.PEAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'Email') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'Email'), 1);
        }
    }
    onEmptySupplierCode(eventObj: any): void {
        this.filterForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }

    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.sourceTypeList = response.Data;
            }
        });
      }

}

